import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-fed-ex-create',
  templateUrl: './fed-ex-create.component.html',
  styleUrls: ['./fed-ex-create.component.scss'],
})
export class FedExCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  clientId: string;
  clientIdError: string;
  clientSecret: string;
  clientSecretError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  clientIdBlur() {
    this.clientIdError = "";
    if (!this.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
  }

  clientSecretBlur() {
    this.clientSecretError = "";
    if (!this.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.clientIdError = "";
    this.clientSecretError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (!this.clientSecret) {
      this.clientSecretError = 'Please enter client secret';
    }
    if (this.carrierNameError != "" || this.clientSecretError != "" || this.clientIdError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {

      "clientId": this.clientId,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": "FE",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "clientSecret": this.clientSecret

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Fed Ex', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
